var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarPlugins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13.888.606c.397.172.633.586.58 1.015l-.913 7.304H21.9c.378 0 .723.22.883.562.16.342.108.747-.134 1.038l-10.5 12.6c-.277.332-.74.442-1.137.27s-.633-.586-.58-1.015l.914-7.305H3c-.378 0-.722-.218-.883-.561-.16-.343-.108-.747.134-1.038l10.5-12.6c.277-.332.74-.442 1.137-.27zm-8.806 12.52h7.368c.28 0 .546.12.731.33.185.209.271.488.237.765l-.638 5.1 7.038-8.446H12.45c-.28 0-.546-.12-.73-.33-.186-.209-.272-.488-.237-.765l.637-5.1-7.038 8.445z",
    clipRule: "evenodd",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarPlugins);
export default __webpack_public_path__ + "static/media/navbar-plugins.99ebc27d5a0fecae0a1e60362b6723ad.svg";
export { ForwardRef as ReactComponent };